import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Go fullscreen to access all hotkeys")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextLabel = _resolveComponent("TextLabel")!
  const _component_IconLabel = _resolveComponent("IconLabel")!
  const _component_LayoutRow = _resolveComponent("LayoutRow")!

  return (_openBlock(), _createBlock(_component_LayoutRow, {
    class: "window-buttons-web",
    onClick: _cache[0] || (_cache[0] = () => _ctx.handleClick()),
    title: (_ctx.fullscreen.state.windowFullscreen ? 'Exit' : 'Enter') + ' Fullscreen (F11)'
  }, {
    default: _withCtx(() => [
      (_ctx.requestFullscreenHotkeys)
        ? (_openBlock(), _createBlock(_component_TextLabel, {
            key: 0,
            italic: true
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_IconLabel, {
        icon: _ctx.fullscreen.state.windowFullscreen ? 'FullscreenExit' : 'FullscreenEnter'
      }, null, 8, ["icon"])
    ]),
    _: 1
  }, 8, ["title"]))
}